import { useContext } from 'react'
import { useQuery, QueryKey } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import ApiContext from '../../context/ApiContext'
import CompanyMember from '../../models/CompanyMember'

export const getCompanyUsersQueryKey = (companyId?: string): QueryKey => ['users', companyId]

interface UseCompanyUsersResult {
	users: CompanyMember[]
	isLoading: boolean
	error: Error | null
	refetch: () => void
}

const useCompanyUsers = (companyId: string | undefined, enabled: boolean = true): UseCompanyUsersResult => {
	const apiContext = useContext(ApiContext)

	const {
		data: users = [],
		isLoading,
		error,
		refetch,
	} = useQuery({
		queryKey: getCompanyUsersQueryKey(companyId),
		queryFn: async (): Promise<CompanyMember[]> => {
			const auth = getAuth()
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(`${apiContext.apiUrl}/companies/${companyId}/users`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${idToken}`,
				},
			})

			if (!response.ok) {
				throw new Error(await response.text())
			}

			return response.json()
		},
		enabled: !!companyId && enabled,
	})

	return { users, isLoading, error: error as Error | null, refetch }
}

export default useCompanyUsers
